export default __webpack_public_path__ + "static/media/bg-about-us.9021ecdf.png";